import { Routes } from '@/routes';

export default {
	'api-key.index': () => import('@/modules/api-keys/index'),
	'api-key.new': () => import('@/modules/api-keys/form'),
	'api-key.edit': () => import('@/modules/api-keys/form'),
} as Routes;
